var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover-container flex",style:(_vm.handleHover),attrs:{"data-testid":"HoverContainer"}},[_c('div',{staticClass:"hover-label",style:({
          background: _vm.position === 'top' ? '#fff' : '#DAE1E9',
          border: _vm.position === 'top' ? '1px solid #DAE1E9' : 'none',
          color: _vm.position === 'top' ? '#DAE1E9' : '#fff' })},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }